// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.funnel-chart {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 8px 0 4px;
}

.funnel-row {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 34px;
}

.funnel-label-group {
  flex: 0 0 160px;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.funnel-label {
  display: block;
  font-size: 12.5px;
  color: var(--an-text-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.funnel-stage-sla {
  font-size: 10.5px;
  line-height: 1.2;
  color: var(--an-text-faint);
}

.funnel-track {
  flex: 1 1;
  height: 26px;
  background: var(--an-surface-alt);
  border-radius: 4px;
  overflow: hidden;
}

.funnel-fill {
  height: 100%;
  border-radius: 4px;
  transition: width 0.2s ease;
}

.funnel-value {
  flex: 0 0 210px;
  text-align: right;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--an-text);
  font-variant-numeric: tabular-nums;
}

.funnel-pct {
  font-weight: 400;
  color: var(--an-text-faint);
  font-size: 11.5px;
}

.funnel-empty {
  padding: 32px 0;
  text-align: center;
  color: var(--an-text-faint);
  font-size: 13px;
}

@media (max-width: 640px) {
  .funnel-label-group {
    flex-basis: 96px;
  }

  .funnel-label {
    font-size: 11.5px;
  }

  .funnel-stage-sla {
    font-size: 9.5px;
  }

  .funnel-value {
    flex-basis: 92px;
    font-size: 11.5px;
  }

  .funnel-pct {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Analytics/charts/FunnelChart.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".funnel-chart {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 8px 0 4px;\n}\n\n.funnel-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-height: 34px;\n}\n\n.funnel-label-group {\n  flex: 0 0 160px;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.funnel-label {\n  display: block;\n  font-size: 12.5px;\n  color: var(--an-text-muted);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.funnel-stage-sla {\n  font-size: 10.5px;\n  line-height: 1.2;\n  color: var(--an-text-faint);\n}\n\n.funnel-track {\n  flex: 1;\n  height: 26px;\n  background: var(--an-surface-alt);\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.funnel-fill {\n  height: 100%;\n  border-radius: 4px;\n  transition: width 0.2s ease;\n}\n\n.funnel-value {\n  flex: 0 0 210px;\n  text-align: right;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--an-text);\n  font-variant-numeric: tabular-nums;\n}\n\n.funnel-pct {\n  font-weight: 400;\n  color: var(--an-text-faint);\n  font-size: 11.5px;\n}\n\n.funnel-empty {\n  padding: 32px 0;\n  text-align: center;\n  color: var(--an-text-faint);\n  font-size: 13px;\n}\n\n@media (max-width: 640px) {\n  .funnel-label-group {\n    flex-basis: 96px;\n  }\n\n  .funnel-label {\n    font-size: 11.5px;\n  }\n\n  .funnel-stage-sla {\n    font-size: 9.5px;\n  }\n\n  .funnel-value {\n    flex-basis: 92px;\n    font-size: 11.5px;\n  }\n\n  .funnel-pct {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
